import { render, staticRenderFns } from "./SafetyHealthCreate.vue?vue&type=template&id=6e3e0b47"
import script from "./SafetyHealthCreate.vue?vue&type=script&lang=js"
export * from "./SafetyHealthCreate.vue?vue&type=script&lang=js"
import style0 from "./SafetyHealthCreate.vue?vue&type=style&index=0&id=6e3e0b47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports